import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import user from "../../assests/user.svg";
import shareButton from "../../assests/shareWithoutBg.svg";
import styles from "./GroupedPopup.module.css";
import closebutton from "../../assests/closebutton.svg";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import { useNavigate } from "react-router";
import ProfilePopup from "../Profile/ProfilePopup";
import multipleFile from "../../assests/multipleFile.svg";
import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import Carousel from "../Carousel/Carousel";
import ReactPlayer from "react-player";
import { useUserAuth } from "../../context/UserAuthContext";
import SharePopup from "../SharePopup/SharePopup";
import useGetUserProfileImage from "../../hooks/useGetUserProfileImage";
import { isEmpty } from "lodash";

export default function GroupedPopup({
  setPopup,
  data,
  selectedIndex,
  contestDetails,
}) {
  const [show, setShow] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [singleFileDetails, setSingleFileDetails] = useState(
    (data?.entries && data?.entries[selectedIndex]) || {}
  );
  const [share, setShare] = useState(false);
  const { newUserId } = useUserAuth();
  const userId = localStorage.getItem("userId");
  let userIdFromLocalOrApi = newUserId || userId;
  const { profilePicture } = useGetUserProfileImage(singleFileDetails);

  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { details, isMobile } = useContext(Context);
  const navigate = useNavigate();

  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };
  const handleFileClick = (obj) => {
    setShowPreview(true);
    setSingleFileDetails(obj);
  };

  function ShareHandle() {
    if (isMobile) {
      let copyText = "";
      if (userIdFromLocalOrApi) {
        copyText =
          "https://share.goviralit.com" +
          "/vidu" +
          userIdFromLocalOrApi +
          "o" +
          singleFileDetails?.orgId +
          "cp" +
          singleFileDetails?.campaignId +
          "cn" +
          singleFileDetails?.contestId +
          "e" +
          singleFileDetails?._id;
      } else {
        copyText =
          "https://share.goviralit.com" +
          "/vid" +
          "o" +
          singleFileDetails?.orgId +
          "cp" +
          singleFileDetails?.campaignId +
          "cn" +
          singleFileDetails?.contestId +
          "e" +
          singleFileDetails?._id;
      }
      if (window.messageHandler) {
        window.messageHandler.postMessage(
          JSON.stringify({
            url: copyText,
            imageUrl: singleFileDetails?.qrCodeUrl,
          })
        );
      } else {
        alert("Flutter messageHandler not found!");
      }
      return;
    }
    setShare(share ? false : true);
  }

  return (
    <>
      {share && (
        <div>
          <div className="absolute h-[100%] w-[100%] flex items-center justify-center top-[-10px]">
            <SharePopup
              showShare={ShareHandle}
              contestant={singleFileDetails}
            />
          </div>
        </div>
      )}
      <div className={styles.popupWrapper}>
        <div
          className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
        >
          <div className={`no-scrollbar ${styles.parentDiv}`}>
            <div className="flex justify-between items-center w-[100%] sticky top-0 left-0 bg-black z-10">
              <p className="text-large-bold p-[20px]">
                {data?.entries && data?.entries[0]?.participantName}
              </p>
              <img
                src={closebutton}
                onClick={() => setPopup(false)}
                className=" hover:cursor-pointer p-[20px]"
              />
            </div>
            <div className="">
              <div className="px-[20px]">
                <div className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414] flex gap-[10px] w-full flex-grow min-w-0 cursor-pointer sticky">
                  <div className="p-[10px] rounded-[12px] h-full w-fit bg-[#2F2F2F] flex flex-col gap-[10px]">
                    <p
                      className="text-regular-bold"
                      style={{ color: contestDetails?.buttonColor }}
                    >
                      {data?.entries && data?.entries[0]?.participantName}
                    </p>
                    {contestDetails?.series_result_key?.map((series) => {
                      const indexofEntry =
                        series?.index == "last"
                          ? data?.entries?.length - 1
                          : series.index;
                      return (
                        <p className="text-small-bold whitespace-nowrap">
                          {series?.displayName} :{" "}
                          {data?.entries &&
                            data?.entries[indexofEntry] &&
                            data?.entries[indexofEntry][series?.name]}
                        </p>
                      );
                    })}
                    <p className="text-small-bold whitespace-nowrap">
                      {contestDetails?.series_like == "AVERAGE"
                        ? "Average"
                        : "Total"}{" "}
                      Votes :{" "}
                      {contestDetails?.series_like == "AVERAGE"
                        ? (
                            data?.entries?.reduce(
                              (sum, item) => sum + (item.likesCount || 0),
                              0
                            ) / data?.entries?.length
                          ).toFixed(0)
                        : data?.entries?.reduce(
                            (sum, item) => sum + (item.likesCount || 0),
                            0
                          )}
                    </p>
                  </div>
                  <div className="flex items-center gap-[10px] overflow-auto customScrollbar">
                    {data?.entries?.map((obj) => (
                      <div
                        className="flex flex-col items-center gap-[5px] shrink-0"
                        onClick={() => setSingleFileDetails(obj)}
                      >
                        <img
                          src={obj?.thumbnailUrl}
                          alt=""
                          className="h-[120px] w-[120px] rounded-[20px] object-cover shrink-0 shadow-sm shadow-[#ffffff7d]"
                          style={{
                            border:
                              singleFileDetails?._id == obj?._id
                                ? `3px solid ${contestDetails?.buttonColor}`
                                : "",
                          }}
                        />
                        <div>
                          <p
                            className="mb-[5px] text-small-bold"
                            style={{ color: contestDetails?.buttonColor }}
                          >
                            {obj[contestDetails?.entry_display_key] || " "}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="seperator" />
              </div>

              {!isEmpty(singleFileDetails) && (
                <div>
                  <div className="flex justify-between items-center w-[100%] gap-[15px] py-[16px] px-[20px]">
                    <div className="flex items-center justify-center gap-[10px] select-none z-[1]">
                      <img
                        src={profilePicture || user}
                        alt=""
                        className="h-[40px] w-[40px] rounded-full overflow-hidden  object-cover"
                      />

                      <p className="text-regular">
                        {singleFileDetails[contestDetails?.entry_display_key] ||
                          " "}
                      </p>
                    </div>
                    <div />
                  </div>
                  <div
                    className="w-[100%] h-[50vh]"
                    style={{
                      background: `url(${
                        singleFileDetails?.fileUrls &&
                        singleFileDetails?.fileUrls[0] &&
                        singleFileDetails?.fileUrls[0].fileUrl
                      }) center center/cover no-repeat`,
                    }}
                  >
                    <div className={styles.imageBg}>
                      {!singleFileDetails?.fileType?.startsWith("audio") && (
                        <Carousel items={singleFileDetails?.fileUrls} />
                      )}

                      {singleFileDetails?.fileType?.startsWith("audio") && (
                        <div className="h-full p-[20px] ">
                          <img
                            src={singleFileDetails?.thumbnailUrl}
                            className={`h-[80%] w-[100%] mx-auto object-contain mb-[10px]`}
                          />
                          <AudioPlayerWithoutDownload
                            fileUrl={
                              singleFileDetails?.fileUrls &&
                              singleFileDetails?.fileUrls[0] &&
                              singleFileDetails?.fileUrls[0].fileUrl
                            }
                            fileName="my voice recording"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="px-[20px]">
                    <div className="py-[16px]  flex justify-between items-center">
                      <div className="flex flex-col">
                        <p className={`whitespace-nowrap`}>
                          {singleFileDetails?.likesCount} Votes
                        </p>
                      </div>

                      <img
                        src={shareButton}
                        alt=""
                        className="w-[36px] h-[36px] hover:cursor-pointer  z-[1]"
                        onClick={ShareHandle}
                      />
                    </div>

                    <div className="seperator mb-[20px]" />

                    {singleFileDetails?.description && (
                      <div
                        className={`text-regular mb-[20px] bg-[#0f0f0f] text-[#f6f6f6] rounded-[10px] py-[16px] px-[10px]`}
                      >
                        <p>{singleFileDetails?.description}</p>
                      </div>
                    )}
                    {contestDetails?.formAttributes?.map((el) => {
                      return (
                        <div className="flex flex-col gap-[30px] px-[4px]">
                          {el?.items?.map((key) => {
                            if (singleFileDetails[key] && el?.display) {
                              if (el.attrType == "media") {
                                return (
                                  <div className="pb-[30px]">
                                    <p
                                      className="text-regular-medium mb-[12px]"
                                      style={{
                                        color: singleFileDetails?.buttonColor
                                          ? singleFileDetails?.buttonColor
                                          : "#FFE100",
                                      }}
                                    >
                                      {el?.title}{" "}
                                    </p>
                                    {el?.type?.startsWith("image") && (
                                      <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                        <img
                                          src={singleFileDetails[key]}
                                          className="w-auto h-[100%]"
                                        />
                                      </div>
                                    )}
                                    {el?.type?.startsWith("video") && (
                                      <div className="h-[320px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                                        <ReactPlayer
                                          playing={false}
                                          controls={true}
                                          width="100%"
                                          height="100%"
                                          url={singleFileDetails[key]}
                                          style={{ objectFit: "contain" }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="pb-[30px]">
                                    <p
                                      className="text-regular-medium mb-[12px]"
                                      style={{
                                        color: singleFileDetails?.buttonColor
                                          ? singleFileDetails?.buttonColor
                                          : "#FFE100",
                                      }}
                                    >
                                      {el?.title}{" "}
                                    </p>
                                    <p className="text-regular-callout  text-[#606060]">
                                      {singleFileDetails[key]}
                                    </p>
                                  </div>
                                );
                              }
                            }
                          })}
                        </div>
                      );
                    })}
                  </div>
                  <div className="seperator mt-[30px]" />
                </div>
              )}
            </div>

            <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
          </div>
        </div>
      </div>
    </>
  );
}
